<div class="">
  <div class="modal-header title-modal-personalized">
    <h2 class="c-form__titulo h1-montserrat text-white">{{ data.title }}</h2>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <h4 class="text-wrap text-fixed-personalized">{{ data.body }}</h4>
    </div>
  </div>
  <hr />
  <div class="d-flex justify-content-center align-content-center mb-2">
    <div class="col-3 p-1" style="max-width: 200px">
      <button class="btn btn-primario" (click)="confirm()">
        <span> Confirmar </span>
      </button>
    </div>
    <div class="col-3 mx-1 p-1">
      <a
        type="button"
        style="max-width: 200px"
        class="btn btn-secondary-cap mx-1"
        (click)="cancel()">
        <span> Cancelar </span>
      </a>
    </div>
  </div>
</div>
